export const DEVELOP_MODE = 'develop';
export const TENGE_LABEL = '₸';
export const KAZAKHSTAN_COUNTRY_CODE = 'KZ';
export const SELFIE_CREDIT_URL =
  'https://selfiecredit.kz/?utm_source=sms&utm_medium=neo_zaglushka_knopka/';
export const PARTNER_REDIRECT_URL = 'https://kazcredy.org/v/9rhxb/?utm_source=neo&utm_campaign=LK';
